/** Human message from an API/Facebook error (server envelope: response.data.error.message),
 *  falling back so a thrown value never surfaces as "[object Object]". */
export function errorMessage(err: unknown, fallback: string): string {
  const e = err as {
    response?: { data?: { error?: { message?: string }; message?: string } };
    message?: string;
  };
  return e?.response?.data?.error?.message || e?.response?.data?.message || e?.message || fallback;
}
